import BreakoutModuleNarrower from './BreakoutModuleNarrower'

export default BreakoutModuleNarrower
